import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import { createPinia } from "pinia";

// ✅ Font Awesome Imports
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faUserMinus, faPenToSquare, faPlus, faTrash, faEye, faArrowRight, faBlog, faBed, faBath, faRulerCombined, faElevator, faLayerGroup } from "@fortawesome/free-solid-svg-icons";
library.add(faUserMinus, faPenToSquare, faPlus, faTrash, faEye, faArrowRight, faBlog, faBed, faBath, faRulerCombined, faElevator, faLayerGroup);

const pinia = createPinia();
const appInstance = createApp(App);
appInstance.use(pinia);

import { useAuthStore } from "@/store/authStore";
import api from "@/services/apiService";

// ✅ Rehydrate Auth Store
const authStore = useAuthStore();
const token = localStorage.getItem("auth_token");
const user = localStorage.getItem("userData");

if (token && user) {
  authStore.token = token;
  authStore.user = JSON.parse(user);
  api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.component("font-awesome-icon", FontAwesomeIcon);
appInstance.mount("#app");
